import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'


// 获取楼层列表
export const getFloorList = params => {
    return get("/admin/floor", params);
};
// 新增楼层
export const addFloor = params => {
    return post("/admin/floor", params);
};
// 修改楼层
export const editFloor = params => {
    return put(`/admin/floor${params.id}`, params);
};
// 删除楼层
export const deleteFloor = params => {
    return del(`/admin/floor/${params}`);
};


// WEBPACK FOOTER //
// ./src/api/floor.js